import { getValidationSchema } from "@Shared/utils/validationSchema";
import * as yup from "yup";
import automaticRelaodParametersFormMeta, { IAutomaticReloadParametersFormMeta } from "./automaticReloadParametersFormMeta";
import initialChargeParametersFormMeta, { I_InitialChargeParametersFormMeta } from "./initialChargeParametersFormMeta";
import limitReloadFormMeta, { ILimitReloadFormMeta } from "./limitReloadFormMeta";

export interface IPrePaidReloadParametersFormMeta extends I_InitialChargeParametersFormMeta, ILimitReloadFormMeta, IAutomaticReloadParametersFormMeta {
  
  schema: any;
}

let prepaidReloadParametersFormMeta = {} as IPrePaidReloadParametersFormMeta;

prepaidReloadParametersFormMeta= {
  ...prepaidReloadParametersFormMeta, ...initialChargeParametersFormMeta, ...limitReloadFormMeta, ...automaticRelaodParametersFormMeta
};

prepaidReloadParametersFormMeta.schema = yup.object().shape(getValidationSchema(prepaidReloadParametersFormMeta));

export default prepaidReloadParametersFormMeta;